// import React, { Component } from "react";
// import { Breadcrumb } from "@gull";
// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from "react-bootstrap-table2-paginator";
// import overlayFactory from "react-bootstrap-table2-overlay";
// import { Row, Col, DropdownButton, Dropdown, Spinner } from "react-bootstrap";
// import memberService from "app/services/memberService";
// import queryString from "app/services/queryStringService";
// import _ from "lodash";
// import { AiFillFileExcel } from "react-icons/ai";
// import Swal from "sweetalert2";
// import { format } from "date-fns";
// import { Helmet } from "react-helmet";
// import { Link } from "react-router-dom";
// import { Accordion, Button, Card } from "react-bootstrap";
// import SearchService from "app/services/SearchService";
// import paymentService from "app/services/paymentService";
// import moment from "moment";
// import {
//   MdEdit,
//   MdDelete,
//   MdAccountBalanceWallet,
//   MdDone,
//   MdClear,
// } from "react-icons/md";
// const { getrequisition, declineReqByDistributor , approveReqByDistributor} = paymentService;
// class AllReq extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       page: 1,
//       data: [],
//       sizePerPage: 10,
//       dataCount: 0,
//       loading: true,
//       memId: 0,
//       FromDate: "",
//       ToDate: "",
//       TransactionMode: "",
//     };
//   }

//   transactionAmountFormatter = (cell, row) => {
//     return <span> ₹ {row.amount} </span>;
//   };
//   transactionModeFormatter = (cell, row) => {
//     return <span>{row.transferMethod?.toUpperCase()} </span>;
//   };
//   dateFormater = (cell, row) => {
//     return new moment(cell ? cell : new Date()).format("MMMM Do YYYY, hh:mm a");
//   };
//   actionFormatter = (cell, row) => {
//     //  console.log(row)
//     if ((row.status == "Pending")) {
//       return (
//         <DropdownButton variant="outline-primary" title="Action" size="sm">
//           <Dropdown.Item
//             href="#"
//             onClick={() => {
//               Swal.fire({
//                 title: `<h1>Approve Credit </h1>`,
//                 html: `<input type="hidden" id="hdnReqId" name="hdnReqId" value=${row.id}>
//                 <textarea style="height:100px;resize:none" id="Reqremarkid" name="Reqremarkid" placeholder="Remark ..." class="swal2-input form-control"></textarea>

//                       </div>`,
//                     //  <input type="checkbox" class="form-check-input" id="ReqcreditSettle" name="ReqcreditSettle" >
//                       //<label class="form-check-label" htmlFor="#creditSettle">Credit Settlement</label>
//                 showCancelButton: true,
//                 confirmButtonText: "Approve",
//                 cancelButtonText: "Back",
//                 showLoaderOnConfirm: true,
//                 allowOutsideClick: false,
//                 preConfirm: async () => {
//                   const data = {
//                     requisitionId: document.getElementById("hdnReqId").value,
//                     remark: document.getElementById("Reqremarkid").value,
//                     // creditSettlement:
//                     //   document.getElementById("ReqcreditSettle").checked,
//                   };
//                 //  debugger
//                   const response = await approveReqByDistributor(data);
//                     console.log(response);
//                   return response;

//                 },
//               }).then(async (result) => {
//                 if (result.isConfirmed) {
//                   if (result.value.status == "Success") {
//                     Swal.fire({
//                       icon: "success",
//                       text: "Requisition approved successfully",
//                     });
//                     await this.loadTransaction();
//                   } else {
//                     Swal.fire({
//                       icon: "error",
//                       text: "Requisition failed",
//                     });
//                   }
//                 }
//               });
//             }}
//           >
//             <MdDone className="text-success mr-4" size={15}></MdDone>
//             Appove
//           </Dropdown.Item>
//           <Dropdown.Item
//             onClick={() => {
//               Swal.fire({
//                 title: `Decline Requisition `,
//                 html: `<input type="hidden" id="declineMemberId" value="${row.id}" />
//                 <textarea style="height:100px;resize:none" id="declineremark" placeholder="Remark ..." class="swal2-input form-control">`,

//                 showCancelButton: true,
//                 confirmButtonText: "Decline",
//                 cancelButtonText: "Back",
//                 showLoaderOnConfirm: true,
//                 allowOutsideClick: false,
//                 preConfirm: async () => {
//                   const data = {
//                     requisitionId:
//                       document.getElementById("declineMemberId").value,
//                     remark: document.getElementById("declineremark").value,
//                   };
//                   const res = await declineReqByDistributor(data);
//                   console.log(res);
//                   return res;

//                 },
//               }).then(async(result) => {
//                 if (result.isConfirmed) {
//                   if (result.value.status === "Success") {
//                     Swal.fire({
//                       title: result.value.message,
//                       text: "Requisition Declined successfully",
//                       icon: "success",
//                     });
//                     await this.loadTransaction();
//                   } else {
//                     Swal.fire("Error occured");
//                   }
//                 }
//               });
//             }}
//           >
//             <MdClear size={15} className="text-danger mr-4"></MdClear>
//             Decline
//           </Dropdown.Item>
//         </DropdownButton>
//       );
//     }
//   };
//   columns = [
//     {
//       dataField: "transactionId",
//       text: "Transaction Id",
//       headerStyle: (colum, colIndex) => {
//         return { textAlign: "center" };
//       },
//     },
//     {
//       dataField: "fromMember.company",
//       text: "From",
//       headerStyle: (colum, colIndex) => {
//         return { width: "150px", textAlign: "center" };
//       },
//     },
//     {
//       dataField: "referenceNo",
//       text: "Ref. Number",
//       headerStyle: (colum, colIndex) => {
//         return {textAlign: "center" };
//       },
//     },
//     {
//       dataField: "requestDate",
//       text: "Req Date and Time",
//       formatter: this.dateFormater,
//       headerStyle: (colum, colIndex) => {
//         return { width: "250px" , textAlign: "center" };
//       },
//     },
//     {
//       dataField: "pgType",
//       text: "Req Type",
//       headerStyle: (colum, colIndex) => {
//         return { width: "150px", textAlign: "center"  };
//       },

//     },
//     {
//       dataField: "transferMethod",
//       text: "Payment Mode",
//       formatter: this.transactionModeFormatter,
//       headerStyle: (colum, colIndex) => {
//         return { width: "150px", textAlign: "center" };
//       },
//     },
//     {
//       dataField: "amount",
//       text: "Amount",
//       formatter: this.transactionAmountFormatter,
//       headerStyle: (colum, colIndex) => {
//         return { width: "150px", textAlign: "center" };
//       },
//     },
//     {
//       dataField: "status",
//       text: "Status",
//       headerStyle: (colum, colIndex) => {
//         return { textAlign: "center" };
//       },
//     },
//     {
//       dataField: "memId",
//       text: "Action",
//       headerStyle: (colum, colIndex) => {
//         return { width: "100px", textAlign: "center" };
//       },
//       formatter: this.actionFormatter,
//     },
//   ];
//   rowStyle = (row, rowIndex) => {
//     const style = {};
//     style.textAlign = "center";
//     style.fontWeight="600";
//     style.verticalAlign = "center";
//     return style;
//   };
//   NoDataIndication = () => {
//     const { loading } = this.state;
//     //alert(loading);
//     if (loading) {
//       return (
//         <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
//       );
//     } else {
//       return (
//         <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
//           <span className="align-middle"></span>
//           <p> No Data Found</p>
//         </div>
//       );
//     }
//   };

//   loadTransaction = async () => {
//     const { page, sizePerPage, FromDate, ToDate, TransactionMode } = this.state;
//     const query = queryString.getQueryStringFromObj({
//       pageNumber: page,
//       pageSize: sizePerPage,
//       FromDate,
//       ToDate,
//       TransactionMode,
//     });
//     if (this.state.dataCount !== 0) {
//       this.setState({ loading: true });
//     }
//     const response = await getrequisition(query);
//     const data = response.data.data;
//     const paggingData = JSON.parse(response.headers["x-pagination"]);
//     this.setState({
//       loading: false,
//       data,
//       dataCount: paggingData.TotalCount,
//       page: paggingData.CurrentPage,
//       sizePerPage: paggingData.PageSize,
//     });
//   };

//   async componentDidMount() {
//     await this.loadTransaction();
//   }

//   // componentWillReceiveProps(nextProps) {
//   //   if (nextProps.memberId !== this.props.memberId) {
//   //     window.setTimeout( async ()=>{
//   //       await this.loadTransaction();
//   //     },100);
//   //   }
//   // }

//   handleTableChange = async (type, { page, sizePerPage }) => {
//     const currentIndex = (page - 1) * sizePerPage;
//     this.setState(() => ({
//       page,
//       sizePerPage,
//     }));
//     setTimeout(async () => {
//       await this.loadTransaction();
//     }, 10);
//   };

//   handleSearch = async () => {
//     this.setState(() => ({
//       page: 1,
//       sizePerPage: 10,
//     }));

//     setTimeout(async () => {
//       await this.loadMember();
//     }, 10);
//   };

//   handleExport = async () => {
//     this.setState(() => ({
//       page: 1,
//       sizePerPage: 10,
//     }));

//     setTimeout(async () => {
//       await this.exportMember();
//     }, 10);
//   };

//   render() {
//     const { data, sizePerPage, page, dataCount, loading } = this.state;

//     const sizePerPageRenderer = ({
//       options,
//       currSizePerPage,
//       onSizePerPageChange,
//     }) => (
//       <>
//         <label className="mr-2">Page Size </label>
//         <div className="btn-group mr-4" role="group">
//           {options.map((option) => {
//             const isSelect = currSizePerPage === `${option.page}`;
//             return (
//               <button
//                 key={option.text}
//                 type="button"
//                 onClick={() => onSizePerPageChange(option.page)}
//                 className={`btn btn-sm ${
//                   isSelect ? "btn-primary" : "btn-secondary"
//                 }`}
//               >
//                 {option.text}
//               </button>
//             );
//           })}
//         </div>
//       </>
//     );

//     const paginationOptions = {
//       paginationSize: 5,
//       pageStartIndex: 1,
//       firstPageText: "First",
//       prePageText: "Back",
//       nextPageText: "Next",
//       lastPageText: "Last",
//       nextPageTitle: "First page",
//       prePageTitle: "Pre page",
//       firstPageTitle: "Next page",
//       lastPageTitle: "Last page",
//       showTotal: true,
//       totalSize: dataCount,
//       sizePerPageList: [
//         {
//           text: "10",
//           value: 10,
//         },
//         {
//           text: "15",
//           value: 15,
//         },
//         {
//           text: "20",
//           value: 20,
//         },
//         {
//           text: "50",
//           value: 50,
//         },
//       ],
//       sizePerPageRenderer,
//     };

//     return (
//       <>
//         <Helmet>
//           <title>All Requisition</title>
//         </Helmet>
//         <Breadcrumb routeSegments={[{ name: "All Requisition" }]}></Breadcrumb>
//         <div className="mb-3">
//           <BootstrapTable
//             hover
//             remote
//             keyField="uniqueIdentity"
//             data={data}
//             columns={this.columns}
//             pagination={paginationFactory(paginationOptions)}
//             onTableChange={this.handleTableChange}
//             noDataIndication={() => <this.NoDataIndication />}
//             loading={loading}
//             overlay={overlayFactory({
//               spinner: true,
//               styles: {
//                 overlay: (base) => ({
//                   ...base,
//                   background: "rgba(120, 120, 120, 0.5)",
//                 }),
//               },
//             })}
//             headerClasses="bg-primary text-white"
//             bodyClasses="react-bootstrap-table-next-min-height"
//             rowStyle={this.rowStyle}
//           />
//         </div>
//       </>
//     );
//   }
// }
// export default AllReq;
import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";
import { Row, Col, DropdownButton, Dropdown } from "react-bootstrap";
import Tooltip from "rc-tooltip";
import queryString from "app/services/queryStringService";
import _ from "lodash";
import { AiFillFileExcel, AiOutlineCopy } from "react-icons/ai";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";

import { Button } from "react-bootstrap";

import {
  getrequisition,
  approveReq,
  declineReq,
  exportRequisition,
  reactiveReq,
} from "app/services/paymentService";
import moment from "moment";
import { MdDone, MdClear, MdSearch, MdRefresh } from "react-icons/md";
// import EditReq from "./EditReq";
import config from "config.json";
import { NotificationManager } from "react-notifications";
import EditReq from "app/views/Admin/Payments/EditReq";
import HandyScroll from "app/common/Scroll";
const { dateFormat } = config;

const AllReq = () => {
  const [filterData, setFilterData] = useState({
    FromDate: "",
    ToDate: "",
    status: "Pending",
    ReqId: 0,
    RequisitionType: "",
  });
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(filterData.FromDate);
  const [toDate, setToDate] = useState(filterData.ToDate);
  const [reqId, setReqId] = useState(filterData.ReqId);
  const [status, setStatus] = useState("Pending");
  const [requisitionType, setRequisitionType] = useState(
    filterData.RequisitionType
  );
  const [showEditReq, setShowEditReq] = useState(false);
  const [isRefreshed, setIsRefreshed] = useState(false);
  const transactionAmountFormatter = (cell, row) => {
    return <span> ₹ {row.amount} </span>;
  };
  const transactionModeFormatter = (cell, row) => {
    return <span>{row.transferMethod?.toUpperCase()} </span>;
  };

  const dateFormater = (cell, row) => {
    if (cell) {
      return (
        new moment(cell).format(dateFormat) +
        "  " +
        moment(row.systemDate).format("HH:mm:ss")
      );
    }
  };
  const tooltipFormatter = (cell, row) => {
    return (
      <>
        <Tooltip
          placement="top"
          overlay={<div style={{ maxWidth: 250 }}>{cell}</div>}
        >
          <span style={{ whiteSpace: "nowrap" }}>
            {cell.substring(0, 10)}...
            <AiOutlineCopy
              className="ml-1"
              onClick={async () => {
                if ("clipboard" in navigator) {
                  await navigator.clipboard.writeText(cell);
                  NotificationManager.success(
                    "Copied successfully ",
                    "Success",
                    5000
                  );
                }
              }}
            />
          </span>
        </Tooltip>
      </>
    );
  };

  const editReqHandler = (row) => {
    setReqId(row.id);
    setShowEditReq(true);
  };
  const reactiveHandler = (row) => {
    Swal.fire({
      // title: `<h6>Do you want to reactivate Requisition?</h6>`,

      html: `<input type="hidden" id="hdnReactiveId" name="hdnReqId" value=${row.id}> `,

      showCancelButton: true,
      confirmButtonText: "Active",
      cancelButtonText: "Back",
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      icon: "question",
      title: "Do you want to reactivate requisition?",
      preConfirm: async () => {
        const data = {
          id: document.getElementById("hdnReactiveId").value,
        };
        const res = await reactiveReq(data);
        return res;
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (result.value.status == "Success") {
          Swal.fire({
            icon: "success",
            text: "Requisition approved successfully",
          });
          await loadTransaction();
        } else {
          Swal.fire({
            icon: "error",
            text: "Requisition failed",
          });
        }
      }
    });
  };

  const actionFormatter = (cell, row) => {
    // console.log(row);
    if (row.status == "Pending") {
      return (
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item
            href="#"
            onClick={() => {
              Swal.fire({
                title: `<h1>Approve Requisition</h1>`,

                html: `<h2> Balance: ${new Intl.NumberFormat(
                  "en-IN",
                  {}
                ).format(row.amount)} </h2>  <h4><b> Ref No - ${
                  row.referenceNo
                }</b></h4> <h6> Username - ${
                  row.fromMember.uniqueIdentity
                } </h6> <h6>  Company - ${
                  row.fromMember.company
                }</h6>   <input type="hidden" id="hdnReqId" name="hdnReqId" value=${
                  row.id
                }> 
                                  
                        <textarea style="height:100px;resize:none;display: block;
                        margin-left: auto;
                        margin-right: auto;
                        width: 80%;"
                         id="Reqremarkid" name="Reqremarkid" placeholder="Remark ..." class="swal2-input form-control"></textarea>
                        ${
                          row.pgType != "CREDIT"
                            ? `<input type="checkbox" className="form-check-input" id="ReqcreditSettle" name="ReqcreditSettle" checked> <label className="form-check-label" htmlFor="#creditSettle"> Credit Settlement</label>`
                            : ""
                        }
                       
                        
                      </div>`,

                showCancelButton: true,
                confirmButtonText: "Approve",
                cancelButtonText: "Back",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                preConfirm: async () => {
                  const data = {
                    requisitionId: document.getElementById("hdnReqId").value,
                    remark: document.getElementById("Reqremarkid").value,
                    creditSettlement: document.getElementById("ReqcreditSettle")
                      ? document.getElementById("ReqcreditSettle").checked
                      : false,
                  };
                  const res = await approveReq(data);
                  return res;
                },
              }).then(async (result) => {
                if (result.isConfirmed) {
                  if (result.value.status == "Success") {
                    Swal.fire({
                      icon: "success",
                      text: "Requisition approved successfully",
                    });
                    await loadTransaction();
                  } else {
                    Swal.fire({
                      icon: "error",
                      text: "Requisition failed",
                    });
                  }
                }
              });
            }}
          >
            <MdDone className="text-success mr-4" size={15}></MdDone>
            Appove
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              Swal.fire({
                title: `Decline Requisition `,
                html: `<h1>Decline Requisition </h1>`,

                html: ` <h2> Balance: ${row.amount} </h2>  <h6> Username - ${row.fromMember.uniqueIdentity} </h6> <h6>  Company - ${row.fromMember.company}</h6> 
                <input type="hidden" id="declineMemberId" value="${row.id}" />
                <textarea style="height:100px;resize:none;display: block;
                margin-left: auto;
                margin-right: auto;
                width: 80%" id="declineremark" placeholder="Remark ..." class="swal2-input form-control"></textarea>`,

                showCancelButton: true,
                confirmButtonText: "Decline",
                cancelButtonText: "Back",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                preConfirm: async () => {
                  const data = {
                    requisitionId:
                      document.getElementById("declineMemberId").value,
                    remark: document.getElementById("declineremark").value,
                  };
                  const res = await declineReq(data);
                  return res;
                },
              }).then(async (result) => {
                if (result.isConfirmed) {
                  if (result.value.status === "Success") {
                    Swal.fire({
                      title: result.value.message,
                      text: "Requisition Declined successfully",
                      icon: "success",
                    });
                    await this.loadTransaction();
                  } else {
                    Swal.fire("Error occured");
                  }
                }
              });
            }}
          >
            <MdClear size={15} className="text-danger mr-4"></MdClear>
            Decline
          </Dropdown.Item>
        </DropdownButton>
      );
    } else if (row.status == "Declined") {
      return <Button onClick={() => reactiveHandler(row)}> Reactive</Button>;
    }
  };
  const columns = [
    {
      dataField: "transactionId",
      text: "Transaction Id",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "fromMember.company",
      text: "From",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "referenceNo",
      text: "Ref. Number",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "requestDate",
      text: "Req Date and Time",
      formatter: dateFormater,
      headerStyle: (colum, colIndex) => {
        return { width: "250px", textAlign: "center" };
      },
    },
    {
      dataField: "pgType",
      text: "Req Type",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transferMethod",
      text: "Payment Mode",
      formatter: transactionModeFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: transactionAmountFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "status",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "memId",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];
  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadTransaction = async () => {
    const state = {
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate: fromDate,
      ToDate: toDate,
      status,
      RequisitionType: requisitionType,
    };
    const query = queryString.getQueryStringFromObj(state);

    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getrequisition(query);
    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setLoading(false);
    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
  };

  const resetTableHandler = async () => {
    const state = {
      pageNumber: page,
      pageSize: sizePerPage,
    };
    const query = queryString.getQueryStringFromObj(state);

    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getrequisition(query);
    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setLoading(false);
    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
  };

  useEffect(() => {
    loadTransaction();
  }, [page, sizePerPage]);

  const refreshFilter = async () => {
    setFromDate(filterData.FromDate);
    setToDate(filterData.ToDate);
    setStatus("Pending");
    setRequisitionType(filterData.RequisitionType);
    setIsRefreshed(true);
  };
  useEffect(() => {
    if (isRefreshed) {
      resetTableHandler();
    }
  }, [isRefreshed]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };
  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setIsRefreshed(false);
    setTimeout(async () => {
      await loadTransaction();
    }, 10);
  };

  const exportAllReq = async () => {
    const query = queryString.getQueryStringFromObj({
      FromDate: fromDate,
      ToDate: toDate,
      status: status,
      RequisitionType: requisitionType,
    });
    if (dataCount != 0) {
      setLoading(true);
    }

    const response = await exportRequisition(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_requisition.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setLoading(false);
  };
  const handleExport = async () => {
    setPage(page);
    setSizePerPage(sizePerPage);

    setTimeout(async () => {
      await exportAllReq();
    }, 10);
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    if (name === "FromDate") setFromDate(value);
    if (name === "ToDate") setToDate(value);
    if (name === "RequisitionType") setRequisitionType(value);
    if (name === "status") setStatus(value);
  };
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size </label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>All Requisition</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "All Requisition" }]}></Breadcrumb>

      <div className="card card-body rounded border mb-2">
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label> Transaction Status</label>
            </div>
            <select
              className="form-control"
              placeholder="Transaction Status"
              name="status"
              value={status}
              onChange={handleSearchChanges}
            >
              <option value="">All</option>
              <option value="Pending">Pending</option>
              <option value="Approved">Approve</option>
              <option value="Declined">Decline</option>
            </select>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label> Transaction Mode</label>
            </div>
            <select
              className="form-control"
              placeholder="Transaction Type"
              name="RequisitionType"
              value={requisitionType}
              onChange={handleSearchChanges}
            >
              <option value="">All</option>
              <option value="CREDIT">Credit</option>
              <option value="NORMAL">Normal</option>
            </select>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label> Date From</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="FromDate"
              // placeholder="Date From"
              value={fromDate}
              onChange={handleSearchChanges}
              max={moment().format("YYYY-MM-DD")}
            />
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label> Date To</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="ToDate"
              //  placeholder="Date To"
              value={toDate}
              onChange={handleSearchChanges}
              max={moment().format("YYYY-MM-DD")}
            />
          </div>

          <div
            className="col d-flex justify-content-around"
            style={{ marginTop: "3%" }}
          >
            <button className="btn btn-outline-primary" onClick={handleSearch}>
              <MdSearch className="mx-2" size={18} />
            </button>
            <Button
              id="btn"
              className="btn btn-primary mx-1"
              onClick={refreshFilter}
            >
              Refresh
            </Button>

            <Button
              variant="outline-primary"
              // className="ml-2"
              onClick={handleExport}
              disabled={!dataCount}
            >
              Export
              <AiFillFileExcel className=" ml-2" />
            </Button>
          </div>
        </div>
      </div>

      <HandyScroll>
        <div
          class="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="uniqueIdentity"
            data={data}
            columns={columns}
            pagination={dataCount > 0 && paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            loading={loading}
            // overlay={overlayFactory({
            //   spinner: true,
            //   styles: {
            //     overlay: (base) => ({
            //       ...base,
            //       background: "rgba(120, 120, 120, 0.5)",
            //       zIndex: "1",
            //     }),
            //   },
            // })}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
      <EditReq
        ReqId={reqId}
        showEditReq={showEditReq}
        loadTransaction={loadTransaction}
      />
    </>
  );
};
// }
export default AllReq;
